import type { UseJobModuleCreateButtonProps } from "./job-module-create-button.type";

import { useJobModulesCreate } from "@/entities/job-module";

export const useJobModuleCreateButton = ({
  module,
  subjectType,
  subjectIds,
}: UseJobModuleCreateButtonProps) => {
  const { mutate, isPending } = useJobModulesCreate({
    invalidateKeys: [[`${subjectType}s.jobModules`, "list"]],
  });

  const triggerModule = () => {
    mutate({
      module_id: module.id,
      subject_type: subjectType,
      subject_ids: subjectIds,
    });
  };

  return {
    triggerModule,
    isPending,
  };
};
